<template>
    <div class="content">
        <div class="geodis-article-header">
            <div class="geodis-article-header__content">
                <div class="container-fluid">
                    <div class="local-task"></div>
                    <h1 class="title__style-1 text-left underline-auto animation-played">
                        <span class="title-inner"
                            ><span class="geodis_blue_color">{{ $t('footer.privacyPolicy') }}</span></span
                        >
                    </h1>
                    <div class="field field--name-field-description field--type-text-long field--label-hidden field--item">
                        <p>
                            {{ $t('footer.privacyPolicyContent.intro.intro1') }}
                        </p>
                        <p>{{ $t('footer.privacyPolicyContent.intro.intro2') }}.&nbsp;</p>
                        <p>
                            {{ $t('footer.privacyPolicyContent.intro.intro3') }}
                            <a href="https://geodis.com/fr/cookies" target="_blank">{{
                                $t('footer.privacyPolicyContent.intro.linkIntro3')
                            }}</a
                            >.
                        </p>
                        <p>{{ $t('footer.privacyPolicyContent.intro.intro4') }}.</p>
                    </div>
                </div>
                <div class="geodis-article-content">
                    <div class="geodis-article-content__inner">
                        <h3 class="title title__style-3 body-title text-left underline-auto animation-played" style="">
                            <div class="title-inner"></div>
                            <div class="underline" style="left: 0px; width: 0px"></div>
                        </h3>
                        <div class="panel-group accordion-style-1" id="shp-main-accordion"></div>
                        <div
                            property="schema:text"
                            class="field field--name-body field--type-text-with-summary field--label-hidden field--item"
                        >
                            <h3>
                                <strong>{{ $t('footer.privacyPolicyContent.whyGeodisProcessYourData.title1') }}</strong>
                            </h3>
                            <p>
                                <strong>{{ $t('footer.privacyPolicyContent.whyGeodisProcessYourData.geodis') }}</strong
                                >&nbsp;{{ $t('footer.privacyPolicyContent.whyGeodisProcessYourData.paragraph') }}
                            </p>
                            <table width="100%" class="lignesEspacees">
                                <tbody>
                                    <tr style="">
                                        <td width="20%">
                                            <p style="text-align: center" align="center">
                                                <span style=""
                                                    ><span style=""
                                                        ><b
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t('footer.privacyPolicyContent.whyGeodisProcessYourData.type')
                                                                }}</span></span
                                                            ></b
                                                        ></span
                                                    ></span
                                                >
                                            </p>
                                        </td>
                                        <td width="40%">
                                            <p style="text-align: center" align="center">
                                                <span style=""
                                                    ><span style=""
                                                        ><b
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t(
                                                                        'footer.privacyPolicyContent.whyGeodisProcessYourData.purpose'
                                                                    )
                                                                }}</span></span
                                                            ></b
                                                        ></span
                                                    ></span
                                                >
                                            </p>
                                        </td>
                                        <td width="40%">
                                            <p style="text-align: center" align="center">
                                                <span style=""
                                                    ><span style=""
                                                        ><b
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t(
                                                                        'footer.privacyPolicyContent.whyGeodisProcessYourData.legalBasis'
                                                                    )
                                                                }}</span></span
                                                            ></b
                                                        ></span
                                                    ></span
                                                ><br />
                                            </p>
                                        </td>
                                    </tr>
                                    <tr style="">
                                        <td width="20%" style="width: 259px; vertical-align: top">
                                            <p style="text-align: start" align="center">
                                                <span style=""
                                                    ><span style=""
                                                        ><b
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t(
                                                                        'footer.privacyPolicyContent.whyGeodisProcessYourData.deliveringServicePurpose.title'
                                                                    )
                                                                }}</span></span
                                                            ></b
                                                        ></span
                                                    ></span
                                                >
                                            </p>
                                        </td>
                                        <td width="40%" style="width: 259px; vertical-align: top">
                                            <ul>
                                                <li style="">
                                                    <span style=""
                                                        ><span style=""
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t(
                                                                        'footer.privacyPolicyContent.whyGeodisProcessYourData.deliveringServicePurpose.item1'
                                                                    )
                                                                }}</span></span
                                                            ></span
                                                        ></span
                                                    >
                                                </li>
                                                <li style="">
                                                    <span style=""
                                                        ><span style=""
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t(
                                                                        'footer.privacyPolicyContent.whyGeodisProcessYourData.deliveringServicePurpose.item2'
                                                                    )
                                                                }}</span></span
                                                            ></span
                                                        ></span
                                                    >
                                                </li>
                                                <li style="">
                                                    <span style=""
                                                        ><span style=""
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t(
                                                                        'footer.privacyPolicyContent.whyGeodisProcessYourData.deliveringServicePurpose.item3'
                                                                    )
                                                                }}</span></span
                                                            ></span
                                                        ></span
                                                    >
                                                </li>
                                                <li style="">
                                                    <span style=""
                                                        ><span style=""
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t(
                                                                        'footer.privacyPolicyContent.whyGeodisProcessYourData.deliveringServicePurpose.item4'
                                                                    )
                                                                }}</span></span
                                                            ></span
                                                        ></span
                                                    >
                                                </li>
                                                <li style="">
                                                    <span style=""
                                                        ><span style=""
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t(
                                                                        'footer.privacyPolicyContent.whyGeodisProcessYourData.deliveringServicePurpose.item5'
                                                                    )
                                                                }}</span></span
                                                            ></span
                                                        ></span
                                                    >
                                                </li>
                                                <li style="">
                                                    <span style=""
                                                        ><span style=""
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t(
                                                                        'footer.privacyPolicyContent.whyGeodisProcessYourData.deliveringServicePurpose.item6'
                                                                    )
                                                                }}</span></span
                                                            ></span
                                                        ></span
                                                    >
                                                </li>
                                            </ul>
                                        </td>
                                        <td width="40%" style="width: 259px; vertical-align: top">
                                            <ul>
                                                <li>
                                                    <span style=""
                                                        ><span style=""
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t(
                                                                        'footer.privacyPolicyContent.whyGeodisProcessYourData.deliveringServicePurpose.item7'
                                                                    )
                                                                }}</span></span
                                                            ></span
                                                        ></span
                                                    ><span style=""
                                                        ><span style=""
                                                            ><span style=""><span style=""> </span></span></span
                                                    ></span>
                                                </li>
                                                <li>
                                                    <span style=""
                                                        ><span style=""
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t(
                                                                        'footer.privacyPolicyContent.whyGeodisProcessYourData.deliveringServicePurpose.item8'
                                                                    )
                                                                }}</span></span
                                                            ></span
                                                        ></span
                                                    ><br />
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr style="">
                                        <td width="20%" style="width: 259px; vertical-align: top">
                                            <p style="text-align: start" align="center">
                                                <span style=""
                                                    ><span style=""
                                                        ><b
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t(
                                                                        'footer.privacyPolicyContent.whyGeodisProcessYourData.cookieManagement.title'
                                                                    )
                                                                }}</span></span
                                                            ></b
                                                        ></span
                                                    ></span
                                                >
                                            </p>
                                        </td>
                                        <td width="40%" style="width: 259px; vertical-align: top">
                                            <ul>
                                                <li>
                                                    <span style=""
                                                        ><span style=""
                                                            ><span style=""
                                                                ><span style=""
                                                                    >{{
                                                                        $t(
                                                                            'footer.privacyPolicyContent.whyGeodisProcessYourData.cookieManagement.item1'
                                                                        )
                                                                    }}&nbsp;<a
                                                                        href="https://geodis.com/fr/cookies"
                                                                        target="_blank"
                                                                        >{{
                                                                            $t(
                                                                                'footer.privacyPolicyContent.whyGeodisProcessYourData.cookieManagement.linkItem1'
                                                                            )
                                                                        }}</a
                                                                    >.</span
                                                                ></span
                                                            ></span
                                                        ></span
                                                    >
                                                </li>
                                            </ul>
                                        </td>
                                        <td width="40%" style="width: 259px; vertical-align: top">
                                            <ul>
                                                <li>
                                                    <span style=""
                                                        ><span style=""
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t(
                                                                        'footer.privacyPolicyContent.whyGeodisProcessYourData.cookieManagement.item2'
                                                                    )
                                                                }}</span></span
                                                            ></span
                                                        ></span
                                                    >
                                                </li>
                                                <li>
                                                    <span style=""
                                                        ><span style=""
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t(
                                                                        'footer.privacyPolicyContent.whyGeodisProcessYourData.cookieManagement.item3'
                                                                    )
                                                                }}</span></span
                                                            ></span
                                                        ></span
                                                    >
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>

                                    <tr style="">
                                        <td width="20%" style="width: 259px; vertical-align: top">
                                            <p style="text-align: start" align="center">
                                                <span style=""
                                                    ><span style=""
                                                        ><b
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t(
                                                                        'footer.privacyPolicyContent.whyGeodisProcessYourData.dataManagement.title'
                                                                    )
                                                                }}</span></span
                                                            ></b
                                                        ></span
                                                    ></span
                                                >
                                            </p>
                                        </td>
                                        <td width="40%" style="width: 259px; vertical-align: top">
                                            <ul>
                                                <li>
                                                    <span style=""
                                                        ><span style=""
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t(
                                                                        'footer.privacyPolicyContent.whyGeodisProcessYourData.dataManagement.item1'
                                                                    )
                                                                }}</span></span
                                                            ></span
                                                        ></span
                                                    >
                                                </li>
                                                <li>
                                                    <span style=""
                                                        ><span style=""
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t(
                                                                        'footer.privacyPolicyContent.whyGeodisProcessYourData.dataManagement.item2'
                                                                    )
                                                                }}</span></span
                                                            ></span
                                                        ></span
                                                    >
                                                </li>
                                            </ul>
                                        </td>
                                        <td width="40%" style="width: 259px; vertical-align: top">
                                            <ul>
                                                <li>
                                                    <span style=""
                                                        ><span style=""
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t(
                                                                        'footer.privacyPolicyContent.whyGeodisProcessYourData.dataManagement.item3'
                                                                    )
                                                                }}</span></span
                                                            ></span
                                                        ></span
                                                    >
                                                </li>
                                                <li>
                                                    <span style=""
                                                        ><span style=""
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t(
                                                                        'footer.privacyPolicyContent.whyGeodisProcessYourData.dataManagement.item4'
                                                                    )
                                                                }}</span></span
                                                            ></span
                                                        ></span
                                                    >
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr style="">
                                        <td width="20%" style="width: 259px; vertical-align: top">
                                            <p style="text-align: start" align="center">
                                                <span style=""
                                                    ><span style=""
                                                        ><b
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t(
                                                                        'footer.privacyPolicyContent.whyGeodisProcessYourData.complyLegal.title'
                                                                    )
                                                                }}</span></span
                                                            ></b
                                                        ></span
                                                    ></span
                                                >
                                            </p>
                                        </td>
                                        <td width="40%" style="width: 259px; vertical-align: top">
                                            <ul>
                                                <li>
                                                    <span style=""
                                                        ><span style=""
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t(
                                                                        'footer.privacyPolicyContent.whyGeodisProcessYourData.complyLegal.item1'
                                                                    )
                                                                }}</span></span
                                                            ></span
                                                        ></span
                                                    >
                                                </li>
                                                <li>
                                                    <span style=""
                                                        ><span style=""
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t(
                                                                        'footer.privacyPolicyContent.whyGeodisProcessYourData.complyLegal.item2'
                                                                    )
                                                                }}</span></span
                                                            ></span
                                                        ></span
                                                    >
                                                </li>
                                                <li>
                                                    <span style=""
                                                        ><span style=""
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t(
                                                                        'footer.privacyPolicyContent.whyGeodisProcessYourData.complyLegal.item3'
                                                                    )
                                                                }}</span></span
                                                            ></span
                                                        ></span
                                                    >
                                                </li>
                                                <li>
                                                    <span style=""
                                                        ><span style=""
                                                            ><span style=""
                                                                ><span style="">{{
                                                                    $t(
                                                                        'footer.privacyPolicyContent.whyGeodisProcessYourData.complyLegal.item4'
                                                                    )
                                                                }}</span></span
                                                            ></span
                                                        ></span
                                                    >
                                                </li>
                                            </ul>
                                        </td>
                                        <td width="40%" style="width: 259px; vertical-align: top">
                                            <ul>
                                                <li style="">
                                                    <span style=""
                                                        ><span style=""
                                                            ><span style=""
                                                                ><span style=""
                                                                    >{{
                                                                        $t(
                                                                            'footer.privacyPolicyContent.whyGeodisProcessYourData.complyLegal.item5'
                                                                        )
                                                                    }}
                                                                </span></span
                                                            ></span
                                                        ></span
                                                    >
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <h3>
                                <strong>{{ $t('footer.privacyPolicyContent.geodisKeepData.title') }}</strong>
                            </h3>
                            <p>
                                {{ $t('footer.privacyPolicyContent.geodisKeepData.paragraph') }}
                            </p>
                            <h3>
                                <strong>{{ $t('footer.privacyPolicyContent.geodisShareData.title') }}</strong>
                            </h3>
                            <p>
                                {{ $t('footer.privacyPolicyContent.geodisShareData.paragraph1') }}
                            </p>
                            <p>
                                {{ $t('footer.privacyPolicyContent.geodisShareData.paragraph2') }}
                            </p>
                            <p>
                                {{ $t('footer.privacyPolicyContent.geodisShareData.paragraph3') }}
                            </p>
                            <p>
                                {{ $t('footer.privacyPolicyContent.geodisShareData.paragraph4') }}
                            </p>
                            <h3>
                                <strong>{{ $t('footer.privacyPolicyContent.transfertData.title') }}</strong>
                            </h3>
                            <p>
                                {{ $t('footer.privacyPolicyContent.transfertData.paragraph1') }}
                            </p>
                            <p>
                                {{ $t('footer.privacyPolicyContent.transfertData.paragraph2') }}
                            </p>
                            <p>
                                {{ $t('footer.privacyPolicyContent.transfertData.paragraph3') }}
                            </p>
                            <h3>
                                <strong>{{ $t('footer.privacyPolicyContent.dataBeSold.title') }}</strong>
                            </h3>
                            <p>
                                {{ $t('footer.privacyPolicyContent.dataBeSold.paragraph') }}
                            </p>
                            <h3>
                                <strong>{{ $t('footer.privacyPolicyContent.geodisProtecteData.title') }}</strong>
                            </h3>
                            <p>
                                {{ $t('footer.privacyPolicyContent.geodisProtecteData.paragraph1') }}
                            </p>
                            <p>
                                {{ $t('footer.privacyPolicyContent.geodisProtecteData.paragraph2') }}
                            </p>
                            <h3>
                                <strong>{{ $t('footer.privacyPolicyContent.rights.title') }}</strong>
                            </h3>
                            <p>
                                {{ $t('footer.privacyPolicyContent.rights.paragraph1') }}
                            </p>
                            <p>
                                {{ $t('footer.privacyPolicyContent.rights.paragraph2') }}
                            </p>
                            <p>
                                {{ $t('footer.privacyPolicyContent.rights.paragraph3') }}
                                <a href="https://geodis.com/fr/contact/gdpr" target="_blank">{{
                                    $t('footer.privacyPolicyContent.rights.link1')
                                }}</a>
                                {{ $t('footer.privacyPolicyContent.rights.ou') }}
                                <a href="mailto:dpo@geodis.com">{{ $t('footer.privacyPolicyContent.rights.link2') }}</a>
                            </p>
                            <p>
                                <strong> {{ $t('footer.privacyPolicyContent.usersEuro.title') }}</strong>
                            </p>
                            <p>{{ $t('footer.privacyPolicyContent.usersEuro.resid1') }}</p>
                            <p>{{ $t('footer.privacyPolicyContent.usersEuro.resid2') }}</p>
                            <p>{{ $t('footer.privacyPolicyContent.usersEuro.resid3') }}</p>
                            <p>{{ $t('footer.privacyPolicyContent.usersEuro.resid4') }}</p>
                            <p>{{ $t('footer.privacyPolicyContent.usersEuro.resid5') }}</p>
                            <p>{{ $t('footer.privacyPolicyContent.usersEuro.resid6') }}</p>
                            <p>
                                <strong>{{ $t('footer.privacyPolicyContent.usersUSA.title') }}</strong>
                            </p>
                            <p>{{ $t('footer.privacyPolicyContent.usersUSA.residUSA1') }}</p>
                            <p>{{ $t('footer.privacyPolicyContent.usersUSA.residUSA2') }}</p>
                            <p>{{ $t('footer.privacyPolicyContent.usersUSA.residUSA3') }}</p>
                            <p>{{ $t('footer.privacyPolicyContent.usersUSA.residUSA4') }}</p>
                            <p>{{ $t('footer.privacyPolicyContent.usersUSA.residUSA5') }}</p>
                            <p>{{ $t('footer.privacyPolicyContent.usersUSA.residUSA6') }}</p>
                            <p>
                                {{ $t('footer.privacyPolicyContent.paragraph') }}
                            </p>
                            <h2>
                                <span class="geodis_blue_color">
                                    {{ $t('footer.privacyPolicyContent.applicableRight.title') }}</span
                                >
                            </h2>
                            <p>
                                {{ $t('footer.privacyPolicyContent.applicableRight.paragraph') }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            component: null
        };
    },
    computed: {},
    methods: {},
    mounted() {},
    watch: {}
};
</script>

<style lang="scss" scoped>
.spacer {
    height: 30px;
}

.lignesEspacees {
    border-collapse: separate;
    border-spacing: 30px;
}
</style>
